// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CcVisa: React.FC = () => {
    return <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 38 38" width="60px">
<title>Visa</title>
<desc>Created with Sketch.</desc>
<g id="Design-Set-4">
	<g id="VD-Checkout-3a_Default" transform="translate(-451.000000, -546.000000)">
		<g id="Visa" transform="translate(451.000000, 546.000000)">
			<path id="Shape" d="M36.7,7H1.3C0.6,7,0,7.6,0,8.3v21.2c0,0.7,0.6,1.3,1.3,1.3h35.5c0.7,0,1.3-0.6,1.3-1.3V8.3
				C38,7.6,37.4,7,36.7,7z M11.2,22.5l-1.6-6.2c0,0-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1c0,0-0.1,0-0.1-0.1
				C9,16,9,16,9,15.9c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2-0.1c0,0-0.1,0-0.1,0
				c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0
				c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0l0-0.1h2.9c0.8,0,0.9,0.6,0.9,0.6l0.6,3.2l0,0l0.2,1.1
				l1.8-4.9h2l-3,7.1L11.2,22.5L11.2,22.5z M15.6,22.5l1.2-7.1h1.9l-1.2,7.1H15.6z M20.7,22.6c-1.3,0-2.1-0.4-2.1-0.4l0.3-1.6
				c0.8,0.6,3.1,0.8,3.1-0.2c0-1-2.6-1-2.6-2.8c0-2,2.2-2.4,3.1-2.4c0.9,0,1.7,0.3,1.7,0.3l-0.3,1.5c-0.8-0.4-2.6-0.5-2.6,0.3
				c0,0.8,2.6,1,2.6,2.8C23.9,21.9,22,22.6,20.7,22.6z M28.7,22.5l-0.2-1.1h-2.4l-0.4,1.1h-1.9l2.8-6.6c0,0,0.2-0.5,0.9-0.5h1.5
				l1.5,7.1H28.7z"/>
			<polygon id="Path" points="26.6,19.9 28.2,19.9 27.6,17.3 			"/>
		</g>
	</g>
</g>
</svg>;
};

export default React.memo(CcVisa);
